export default "__VITE_ASSET__CGAyda8N__"